import { createContext } from "react";
import type { AuthContextType } from "./AuthProvider";

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Add display name for better debugging
AuthContext.displayName = 'AuthContext';